import { render, staticRenderFns } from "./ListRuangan.vue?vue&type=template&id=34e4d496"
import script from "./ListRuangan.vue?vue&type=script&lang=js"
export * from "./ListRuangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports